<template>
  <div  :class="[print?$.printtemplate:'',$.panel]" >
    <h4 class="title">
      {{data.examName||'八斗金人力资源招聘'}}
      <p class="subtitle">准考证</p>
    </h4>
    <div :class="$.template1" v-show="showType==0">
      <div class="left">
        <div class="row">
          <div>
            <label>准考证号:</label>
            <span>{{data.examNumber||'456xxxx'}}</span>
          </div>
          <div>
            <label>考生姓名:</label>
            <span>{{data.fullName||'小明'}}</span>
          </div>
        </div>
        <div class="row">
          <div>
            <label>座位号:</label>
            <span>{{data.seatNumber||'001'}}</span>
          </div>
          <div>
            <label>身份证号:</label>
            <span>{{data.idNumber||'45xxxxxx'}}</span>
          </div>
        </div>
        <div class="row">
          <div>
            <label>考生性别:</label>
            <span>{{data.sex===1?'男':'女'}}</span>
          </div>
          <div>
            <label>报考岗位:</label>
            <span>{{data.examPostName||'工程师'}}</span>
          </div>
        </div>
        <div class="row">
          <div>
            <label>考点名称:</label>
            <span>{{data.examAddressName||'xx考点'}}</span>
          </div>
          <div>
            <label>考场名称:</label>
            <span>{{data.examPlaceName||'xx考场'}}</span>
          </div>
        </div>
        <div class="row">
          <div>
            <label>考试时间:</label>
            <span>{{data.examTime||'考试时间'}}</span>
          </div>
        </div>
      </div>
      <div class="flex_row flex_row_photo right">
        <a class="photo_wrap">
          <!-- <img :src="data.photo?getUrl(data.photo):`../assets/404.png`" /> -->
          <img :src="data.photo?getUrl(data.photo):require('../assets/default.jpg')" />
        </a>
      </div>
    </div>
    <!--模板2start-->
    <div :class="[$.template1,$.template2]" v-show="showType == 1">
      <div class="flex_row flex_row_photo right">
        <a class="photo_wrap">
          <!-- <img :src="data.photo?getUrl(data.photo):`../assets/404.png`" /> -->
          <img :src="data.photo?getUrl(data.photo):require('../assets/default.jpg')" />
        </a>
      </div>
      <div class="left">
        <div class="row">
          <div>
            <label>准考证号:</label>
            <span>{{data.examNumber||'456xxxx'}}</span>
          </div>
          <div>
            <label>考生姓名:</label>
            <span>{{data.fullName||'小明'}}</span>
          </div>
        </div>
        <div class="row">
          <div>
            <label>座位号:</label>
            <span>{{data.seatNumber||'001'}}</span>
          </div>
          <div>
            <label>身份证号:</label>
            <span>{{data.idNumber||'45xxxxxx'}}</span>
          </div>
        </div>
        <div class="row">
          <div>
            <label>考生性别:</label>
            <span>{{data.sex===1?'男':'女'}}</span>
          </div>
          <div>
            <label>报考岗位:</label>
            <span>{{data.examPostName||'工程师'}}</span>
          </div>
        </div>
        <div class="row">
          <div>
            <label>考点名称:</label>
            <span>{{data.examAddressName||'xx考点'}}</span>
          </div>
          <div>
            <label>考场名称:</label>
            <span>{{data.examPlaceName||'xx考场'}}</span>
          </div>
        </div>
        <div class="row">
          <div>
            <label>考试时间:</label>
            <span>{{data.examTime||'考试时间'}}</span>
          </div>
        </div>
      </div>
    </div>
    <!--模板2end-->
    <div :class="$.tips">
      <span>注意事项</span>
      <div v-html="note" v-if="note" :class="$.note"></div>
      <template v-else>
        <div>1.考生应携带xxxx</div>
        <div>2.考生应携带xxxx</div>
        <div>3.考生应携带xxxx</div>
      </template>
    </div>
  </div>
</template>

<script>
import FileUrlMixin from "@/mixins/FileUrlMixin";
export default {
  mixins: [FileUrlMixin],
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    note: {
      type: String,
      default: ""
    },
    showType: {
      type: String,
      default: "0"
    },
    print:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {};
  }
};
</script>


<style lang="scss" module="$">
.printtemplate{
  position: absolute;
  // width: 100%;
  margin: auto;
 top: 0;
 right: 0;
  left: 0;
  z-index: -1;
  // opacity: 0;
}
.panel {
  border: 1px solid #aaa;
  // padding: 10px;
  margin-top: 20px;
  :global {
    .title {
      text-align: center;
      margin: 0;
      border-bottom: 1px solid #eee;
      padding: 17px 0;
      margin: 0;
      font-size: 19px
    }
    .subtitle {
      margin: 0;
      font-size: 33px;
      margin-top: 10px;
      letter-spacing: 74px;
      margin-left: 70px;
    }
  }
}

.template1 {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  overflow: hidden;
  :global {
    .left {
      // flex-basis: 500px;
      flex-grow: 1;
      flex-shrink: 0;
      border-right: 1px solid #eee;
      & > .row:nth-last-of-type(1) {
        border-bottom: 0;
      }
      & > .row:not(:nth-last-of-type(1)) > div:nth-of-type(1) {
        &::after {
          position: absolute;
          content: "";
          width: 2px;
          height: calc(100% + 28px);
          background-color: #eee;
          right: 0;
          top: -15px;
        }
      }
      & > .row:nth-last-of-type(1) > div {
        flex-basis: 100% !important;
      }
    }
    .row {
      display: flex;
      // justify-content: space-between;
      justify-content: baseline;
      padding: 14px 0;
      border-bottom: 1px solid #eee;
      & > div:nth-of-type(1) {
        position: relative;
        flex-basis: 40% !important;
      }
      & > div {
        flex-grow: 0;
        flex-basis: 50%;
        padding-left: 16px;
      }
    }
    .flex_row {
      display: flex;
      justify-content: space-between;
      flex: 1;
      // margin-bottom: 20px;
    }
    .flex_row_photo {
      flex-basis: 150px;
      flex-grow: 0;
      display: inline-flex;
      align-items: center;
    }

    .photo_wrap {
      display: block;
      height: 100%;
      min-width: 150px;
      width: 100%;
      min-height: 131px;
      // padding: 10px;
      position: relative;
      // max-height: 165px;
      & > img {
        width: 82%;
        height: 100%;
        max-height: 200px;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
      }
    }
  }
}
.template2 {
  :global {
    .left {
      border-left: 1px solid #eee;
    }
    .row {
      border: 0;
    }
    .row > div:nth-of-type(1) {
      &::after {
        position: absolute;
        content: "";
        width: 0px !important;
        height: calc(100% + 34px);
        background-color: #eee;
        right: 0;
        top: -17px;
      }
    }
  }
}
.tips {
  margin: 20px;
  & span {
    font-weight: bold;
    font-size: 13px;
    display: inline-block;
    margin-bottom: 5px;
  }
}
.note{
  overflow: hidden;
  &>p{
    text-indent: 0 !important;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
@media print {
.note {page-break-after: always;}
}
</style>